import React from 'react';
import ReactLoading from 'react-loading';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTh } from '@fortawesome/free-solid-svg-icons';
import { Filter } from '../components/fields';
import { SaveProductModal, ProductCategoryModal } from '../components/modals';
import ImportMenuModal from '../components/modals/ImportMenuModal';
import ExtrasModal from '../components/modals/ExtrasModal';
import { Toast, Confirm } from '../components/alerts';
import { VenueReserveCard } from '../components/cards';
import { ProductService } from '../services';
import { LocalStorage } from '../utils';

import '../styles/product.css';

class ProductPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      searchText: '',
      filter: LocalStorage.getFilter(),
      products: null,
      selectedBars: [],
    };

    this.addProductBtnClick = this.addProductBtnClick.bind(this);
    this.categoryBtnClick = this.categoryBtnClick.bind(this);
    this.fetchStock = this.fetchStock.bind(this);
    this.onSearchChange = this.onSearchChange.bind(this);
    this.onFilterChange = this.onFilterChange.bind(this);
    this.onAddProductComplete = this.onAddProductComplete.bind(this);
    this.onProductEnabledChange = this.onProductEnabledChange.bind(this);
    this.onBarEnabledChange = this.onBarEnabledChange.bind(this);

    this.productService = new ProductService();
  }

  componentDidMount() {
    this.fetchStock();
  }

  addProductBtnClick() {
    const { filter } = this.state;
    const { t } = this.props;

    if (filter.venue) {
      this.saveProductModal.show(true, filter.venue);
    } else {
      Toast.warning(t('Please select a venue from filter!'));
    }
  }

  importMenuBtnClick = () => {
    const { filter } = this.state;

    if (filter && filter.venue) {
      this.importMenuModal.show(true, filter.venue);
    } else {
      Toast.warning('Please select a venue from filter!');
    }
  };

  deleteAllBtnClick = async () => {
    const { filter, products } = this.state;

    if (!filter || !filter.venue) {
      Toast.warning('Please select a venue from filter!');
      return;
    }

    const list = products || [];
    if (!list.length) {
      Toast.warning('There are no products to delete.');
      return;
    }

    const typed = window.prompt(`Delete all ${list.length} products from ${filter.venue.name}?\n\nType "delete all" to confirm.`);
    if (!typed || typed.trim().toLowerCase() !== 'delete all') return;

    this.setState({ loading: true });

    let failed = 0;
    for (const product of list) {
      try {
        const result = await this.productService.delete(filter.venue._id, product._id);
        if (!result || !result.success) failed++;
      } catch (e) {
        failed++;
      }
    }

    await this.fetchProducts();

    if (failed) {
      Toast.warning(`${list.length - failed} deleted, ${failed} could not be deleted.`);
    } else {
      Toast.success(`${list.length} products deleted`);
    }
  };

  extrasBtnClick = () => {
    const { filter } = this.state;

    if (filter && filter.venue) {
      this.extrasModal.show(true, filter.venue);
    } else {
      Toast.warning('Please select a venue from filter!');
    }
  };

  categoryBtnClick() {
    const { filter } = this.state;
    const { t } = this.props;

    if (filter.venue) {
      this.prodcutCategoryModal.show(true, filter.venue);
    } else {
      Toast.warning(t('Please select a venue from filter!'));
    }
  }

  async fetchStock() {
    const { filter, searchText } = this.state;

    this.setState({ loading: true });

    const productResult = await this.productService.getStock({ venue_id: filter && filter.venue ? filter.venue._id : null, search: searchText });

    if (productResult && productResult.success) {
      this.setState({ products: productResult.products, selectedBars: productResult.selected_bars, filter: { ...filter, venue: productResult.selected_venue } });

      if (this.filter) {
        this.filter.setFilterFields('venue', productResult.selected_venue);
        this.filter.showTags();
      }
    }

    this.setState({ loading: false });
  }

  onSearchChange(searchText) {
    this.setState(
      {
        searchText: searchText,
        loading: true,
      },
      () => {
        this.fetchStock();
      }
    );
  }

  onFilterChange(filter) {
    if (filter.venue) {
      this.setState({ filter: filter }, () => {
        this.fetchStock();
      });
    } else {
      this.setState({ filter: {}, products: null }, () => {
        this.fetchStock();
      });
    }
  }

  onAddProductComplete() {
    this.fetchStock();
  }

  onVenueReserveCardChange = async (data, action) => {
    switch (action.label) {
      case 'EDIT':
        this.saveProductModal.show(true);
        this.saveProductModal.setFields(data);
        break;
      case 'DELETE': {
        const confirm = await Confirm.open(
          this.props.t('Remove Product'),
          this.props.t('Remove this product from your menu? Historical order data will be kept.'),
          this.props.t('Yes'),
          this.props.t('No')
        );

        if (confirm) {
          const result = await this.productService.delete(data.venue._id, data._id);

          if (result && result.success) {
            this.fetchStock();
          } else {
            Toast.warning(this.props.t('Unable to remove product'));
          }
        }
        break;
      }
      default:
        break;
    }
  }

  onProductEnabledChange(enabled, productId) {
    const { products } = this.state;

    const newProducts = products.map((product) => {
      if (product._id === productId) {
        product.enabled = enabled;
      }
      return product;
    });

    this.setState({ products: newProducts });
  }

  onBarEnabledChange(enabled, productId, barId) {
    const { products } = this.state;

    const newProducts = products.map((product) => {
      if (product._id === productId) {
        product.barproducts = product.barproducts.map((barProduct) => {
          if (barProduct.bar._id === barId) {
            barProduct.enabled = enabled;
          }

          return barProduct;
        });
      }

      return product;
    });

    this.setState({ products: newProducts });
  }

  onEnabledChangeError(error) {
    this.fetchStock();

    if (error) {
      Toast.warning(`Fatal Error Occurred ${error}`);
    }
  }

  render() {
    const { loading, products, searchText, selectedBars } = this.state;
    const { t, me, label } = this.props;

    return (
      <div className='content'>
        <SaveProductModal
          onRef={(ref) => (this.saveProductModal = ref)}
          selectedBars={selectedBars}
          onComplete={this.onAddProductComplete}
          onNoResultFound={() => {
            this.categoryBtnClick();
          }}
        />
        <ProductCategoryModal onRef={(ref) => (this.prodcutCategoryModal = ref)}></ProductCategoryModal>
        <ExtrasModal onRef={(ref) => (this.extrasModal = ref)} onComplete={() => window.location.reload()} />
        <ImportMenuModal onRef={(ref) => (this.importMenuModal = ref)} onComplete={this.onAddProductComplete} />
        <div className='content-title'>
          <div className='content-title-label'>{label}</div>
          <div className='content-title-buttons'>
            {(me.role === 'ADMIN' || me.role === 'MANAGER') && (
              <>
                {me.is_superadmin && (
                  <button className='content-title-button default' onClick={this.importMenuBtnClick}>
                    IMPORT MENU
                  </button>
                )}
                {me.is_superadmin && (
                  <button className='content-title-button default' onClick={this.deleteAllBtnClick}>
                    DELETE ALL
                  </button>
                )}
                <button className='content-title-button default' onClick={this.extrasBtnClick}>
                  EXTRAS
                </button>
                <button className='content-title-button default' onClick={this.categoryBtnClick}>
                  <FontAwesomeIcon icon={faTh} /> {t('CATEGORIES')}
                </button>
                <button className='content-title-button' onClick={this.addProductBtnClick}>
                  <FontAwesomeIcon icon={faPlus} /> {t('ADD PRODUCT')}
                </button>
              </>
            )}
          </div>
        </div>
        <div className='content-body'>
          <div className='content-header'>
            <Filter onRef={(ref) => (this.filter = ref)} searchText={searchText} fields={['venue']} onSearchChange={this.onSearchChange} onFilterChange={this.onFilterChange} />
          </div>
          {loading ? (
            <div className='margin-auto'>
              <ReactLoading type='spin' color='#000' height='24px' width='24px' />
            </div>
          ) : (
            <div className='product-page-venue'>
              {products && (
                <div>
                  <Row>
                    {products.length < 1 && <Col md={12}>{t('No products found')}</Col>}
                    {products.map((product) => {
                      return (
                        <VenueReserveCard
                          key={product._id}
                          product={product}
                          actions={[
                            {
                              label: 'EDIT',
                              title: t('EDIT'),
                            },
                            {
                              label: 'DELETE',
                              title: t('DELETE'),
                              red: true,
                            },
                          ]}
                          onChange={this.onVenueReserveCardChange}
                          onEnabledChange={this.onProductEnabledChange}
                          onBarEnabledChange={this.onBarEnabledChange}
                          onEnabledChangeError={this.onEnabledChangeError}
                        />
                      );
                    })}
                  </Row>
                </div>
              )}
              <br />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withTranslation()(withRouter(ProductPage));
